/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page MNG_Accident004
 * @created at      :   2025/08/01
 * @created by      :   DaoNX
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
const dataInit = {
    working_date_start: '',
    company: 'ムーヴ',
    period: 1
};
export default {
    namespaced: true,
    state: {
        data: { ...dataInit },
        dataTable: {
            accidentAnnouncementData: [
                {
                    area: '西日本',
                    vehicle: 0,
                    property: 1,
                    injury: 2,
                    claim: 0,
                    total: 3,
                    workers: 4441,
                    rate: 0.068,
                    prevRate: 0.218
                },
                {
                    area: '中日本',
                    vehicle: 0,
                    property: 1,
                    injury: 3,
                    claim: 1,
                    total: 5,
                    workers: 1744,
                    rate: 0.287,
                    prevRate: 0.486
                },
                {
                    area: '東日本',
                    vehicle: 1,
                    property: 4,
                    injury: 3,
                    claim: 0,
                    total: 8,
                    workers: 6467,
                    rate: 0.124,
                    prevRate: 0.092
                },
                {
                    area: '北日本',
                    vehicle: 0,
                    property: 1,
                    injury: 0,
                    claim: 0,
                    total: 1,
                    workers: 476,
                    rate: 0.21,
                    prevRate: 0.428
                },
                {
                    area: '合計',
                    vehicle: 1,
                    property: 7,
                    injury: 8,
                    claim: 1,
                    total: 17,
                    workers: 13128,
                    rate: 0.129,
                    prevRate: 0.192
                }
            ],
            // 全社
            wholeCompanyData: [
                {
                    label: '運搬',
                    landing: 1,
                    collision: 1,
                    tumbling: 1,
                    other: 2,
                    total: 5
                },
                {
                    label: '積み込み',
                    landing: 0,
                    collision: 0,
                    tumbling: 0,
                    other: 0,
                    total: 0
                },
                {
                    label: '荷卸し',
                    landing: 0,
                    collision: 0,
                    tumbling: 0,
                    other: 0,
                    total: 0
                },
                {
                    label: '他',
                    landing: 1,
                    collision: 0,
                    tumbling: 0,
                    other: 1,
                    total: 2
                },
                {
                    label: '合計',
                    landing: 2,
                    collision: 1,
                    tumbling: 1,
                    other: 3,
                    total: 7
                }
            ],
            // 西日本
            westJapanData: [
                {
                    label: '運搬',
                    landing: 0,
                    collision: 0,
                    tumbling: 0,
                    other: 1,
                    total: 1
                },
                {
                    label: '積み込み',
                    landing: 0,
                    collision: 0,
                    tumbling: 0,
                    other: 0,
                    total: 0
                },
                {
                    label: '荷卸し',
                    landing: 0,
                    collision: 0,
                    tumbling: 0,
                    other: 0,
                    total: 0
                },
                {
                    label: '他',
                    landing: 0,
                    collision: 0,
                    tumbling: 0,
                    other: 0,
                    total: 0
                },
                {
                    label: '合計',
                    landing: 0,
                    collision: 0,
                    tumbling: 0,
                    other: 1,
                    total: 1
                }
            ],
            // 中日本
            inJapanData: [
                {
                    label: '運搬',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: 1,
                    total: null
                },
                {
                    label: '積み込み',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: null,
                    total: null
                },
                {
                    label: '荷卸し',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: null,
                    total: null
                },
                {
                    label: '他',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: null,
                    total: null
                },
                {
                    label: '合計',
                    landing: 0,
                    collision: 0,
                    tumbling: 0,
                    other: 1,
                    total: 1
                }
            ],
            // 東日本
            eastJapanData: [
                {
                    label: '運搬',
                    landing: 1,
                    collision: 1,
                    tumbling: null,
                    other: 1,
                    total: 1
                },
                {
                    label: '積み込み',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: null,
                    total: 0
                },
                {
                    label: '荷卸し',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: null,
                    total: 0
                },
                {
                    label: '他',
                    landing: 1,
                    collision: null,
                    tumbling: null,
                    other: null,
                    total: 1
                },
                {
                    label: '合計',
                    landing: 2,
                    collision: 0,
                    tumbling: 0,
                    other: 1,
                    total: 3
                }
            ],
            // 北日本
            northJapanData: [
                {
                    label: '運搬',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: null,
                    total: 0
                },
                {
                    label: '積み込み',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: null,
                    total: 0
                },
                {
                    label: '荷卸し',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: null,
                    total: 0
                },
                {
                    label: '他',
                    landing: null,
                    collision: null,
                    tumbling: null,
                    other: 1,
                    total: 1
                },
                {
                    label: '合計',
                    landing: 0,
                    collision: 0,
                    tumbling: 0,
                    other: 1,
                    total: 1
                }
            ],
            // 事故発生件数
            accidentOccurrence: [
                {
                    id: 1,
                    label: '1月',
                    west: 0.178,
                    during: 0.119,
                    east: 0.187,
                    north: 0.0,
                    total: 0.169
                },
                {
                    id: 2,
                    label: '2月',
                    west: 0.075,
                    during: 0.256,
                    east: 0.109,
                    north: 0.239,
                    total: 0.173
                },
                {
                    id: 3,
                    label: '3月',
                    west: 0.279,
                    during: 0.236,
                    east: 0.086,
                    north: 0.673,
                    total: 0.188
                },
                {
                    id: 4,
                    label: '4月',
                    west: 0.046,
                    during: 0.045,
                    east: 0.085,
                    north: 0.0,
                    total: 0.065
                },
                {
                    id: 5,
                    label: '5月',
                    west: 0.218,
                    during: 0.486,
                    east: 0.092,
                    north: 0.428,
                    total: 0.192
                },
                {
                    id: 6,
                    label: '6月',
                    west: 0.068,
                    during: 0.287,
                    east: 0.124,
                    north: 0.21,
                    total: 0.129
                },
                {
                    id: 7,
                    label: '下期平均',
                    west: 0.114,
                    during: 0.29,
                    east: 0.114,
                    north: 0.258,
                    total: 0.153
                },
                {
                    id: 8,
                    label: '上期平均',
                    west: 0.198,
                    during: 0.464,
                    east: 0.14,
                    north: 0.258,
                    total: 0.212
                }
            ]
        },

        options: {
            period: [
                {
                    code: 1,
                    name: '下期'
                },
                {
                    code: 2,
                    name: '表示'
                }
            ],
            pageSize: [
                {
                    code: 999,
                    name: '全件表示'
                },
                {
                    code: 100,
                    name: '100件'
                },
                {
                    code: 50,
                    name: '50件'
                }
            ]
        },
        draftOption: {},
        dataChart: {
            data: {
                labels: ['JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
                datasets: [
                    {
                        label: '今年',
                        maxBarThickness: 50,
                        data: [1000, 2000, 3000, 2500, 2700, 2400, 3000], // xanh dương
                        backgroundColor: '#0084ff'
                    },
                    {
                        label: '去年',
                        maxBarThickness: 50,
                        data: [700, 1700, 2800, 1900, 1800, 1500, 2000], // xám
                        backgroundColor: '#d3d9df'
                    }
                ]
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        labels: {
                            padding: 20,
                            boxWidth: 50,
                            boxHeight: 1,
                            sort: function (a, b) {
                                return a.order - b.order;
                            },
                            generateLabels: function (chart) {
                                return chart.data.datasets.map((item) => {
                                    let customLabel = {};
                                    if (item.type == 'line') {
                                        customLabel = {
                                            text: item.label,
                                            strokeStyle: item.borderColor,
                                            order: 2,
                                            lineDash: item.borderDash,
                                            fillStyle: 'white'
                                        };
                                    } else {
                                        customLabel = {
                                            text: item.label,
                                            fillStyle: item.backgroundColor,
                                            strokeStyle: item.backgroundColor,
                                            order: 1,
                                            lineWidth: 10
                                        };
                                    }
                                    return customLabel;
                                });
                            }
                        },
                        onClick: function () {},
                        font: {
                            size: 14,
                            weight: 'normal'
                        }
                    },
                    title: {
                        display: true,
                        text: '',
                        font: {
                            size: 20,
                            weight: 'normal'
                        }
                    }
                },
                scales: {
                    y: {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        min: 0,
                        max: 3000,
                        ticks: {
                            stepSize: 500,
                            callback: (val) => {
                                if (val >= 1000) return `$${val / 1000}k`;
                                if (val > 0) return `$${val}`;
                                return '$0';
                            }
                        }
                    },
                    x: {
                        ticks: {
                            autoSkip: true
                        },
                        grid: {
                            display: false
                        }
                    }
                }
            },
            styles: {
                minHeight: '350px',
                maxHeight: '350px',
                width: '100%',
                display: 'unset'
            }
        },
        paginationData: {
            pageNo: 1,
            pageSize: 999,
            totalRows: 0,
            msgNoData: '該当するデータが存在しません。'
        }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.paginationData.pageNo = 1;
            state.paginationData.pageSize = 999;
            state.paginationData.totalRows = 0;
            state.paginationData.msgNoData = '該当するデータが存在しません。';
        },
        setAccidentAnnouncementData(state, data) {
            state.accidentAnnouncementData = data ?? [];
        },
        setPageNavigation(state, data) {
            state.paginationData.pageNo = parseInt(data.page);
            state.paginationData.pageSize = parseInt(data.pageSize);
            state.paginationData.totalRows = parseInt(data.totalRows);
            state.paginationData.msgNoData = parseInt(data.totalRows) == 0 ? '該当するデータが存在しません。' : '';
        },
        setCombobox(state, data) {
            // var status = data.filter((item) => item.code !== '0');
            state.draftOption = data.filter((item) => item.code == '0');
            // state.options.status = status;
        }
    },
    actions: {
        actionSearch(context, request) {
            try {
                // Fake data for development
                const fakeData = {
                    Code: 200,
                    Data: {
                        accidentAnnouncementData: [],
                        paging: {
                            page: 1,
                            pageSize: 999,
                            totalRows: 6
                        }
                    }
                };

                context.commit('setAccidentAnnouncementData', fakeData.Data.accidentAnnouncementData);
                context.commit('setPageNavigation', fakeData.Data.paging);

                // callback
                if (request.callback) {
                    request.callback(fakeData);
                }
            } catch (e) {
                console.error('Search: ' + e.message);
            }
        }
    }
};
